import icons from './icons'
import schemas from './schemas'
import resourceSettings from './resources'
import units from './units'

const {
  resources,
  resourceOrder,
  getSections,
} = resourceSettings

const settings = {
  title: 'QuoteRight',
  api: '/api/v1',
  googleLogin: '/api/v1/auth/google',
  devMode: process.env.NODE_ENV === 'development',
  snackbarAutoHide: 5000,
  icons,
  sideMenuWidth: 250,
  resources,
  resourceOrder,
  getSections,
  units,
  projectSchema: schemas.project,
  clientSchema: schemas.client,
  quoteSchema: schemas.quote,
  resourceSchemas: schemas.resource,
  sideMenu: ({
    loggedIn,
    activeProject,
    handlers,
  }) => {
    if(loggedIn) {

      let menu = []
      
      if(activeProject) {
        menu = menu.concat([{
          title: 'Settings',
          handler: ['project.edit', {id: activeProject.id}],
          icon: icons.settings,
        }, '-', {
          title: 'Clients',
          handler: 'client.list',
          icon: icons.client,
        },{
          title: 'Quotes',
          handler: 'quote.list',
          icon: icons.quote,
        }, '-'])
        
        menu = menu.concat(resourceOrder.map(name => {
          const resource = resources[name]
          return {
            title: resource.title,
            icon: resource.icon,
            handler: ['resource.list', {
              section: name,
              parentid: 'root',
            }],
          }
        }))
        menu.push('-')
      }

      menu.push({
        title: 'Workspaces',
        handler: 'project.list',
        icon: icons.project,
      })

      menu.push({
        title: 'Payment',
        handler: 'payment',
        icon: icons.payment,
      })

      menu.push('-')

      menu.push({
        title: 'Logout',
        handler: handlers.logout,
        icon: icons.logout,
      })

      return menu
    }
    else {
      return [{
        title: 'Login',
        handler: 'login',
        icon: icons.login,
      }]
    }
  },
  appbarMenu: ({
    loggedIn,
    handlers,
  }) => {
    if(loggedIn) {
      return [{
        title: 'Payment',
        handler: 'payment',
        icon: icons.payment,
      }, {
        title: 'Logout',
        handler: handlers.logout,
        icon: icons.logout,
      }]
    }
    else {
      return [{
        title: 'Login',
        handler: 'login',
        icon: icons.login,
      }]
    }
  },
}

export default settings